import { moduleActionContext } from '@/store'
import state from './team.state'
import getters from './team.getters'
import actions from './team.actions'
import mutations from './team.mutations'

const teamModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} as const

export default teamModule
export const teamModuleActionContext = context => moduleActionContext(context, teamModule)
